import React from "react";
import { Alert, ControlLabel, FormGroup, HelpBlock } from "components/bootstrap";
import { Select } from "components/common";
import { ConfigurationFormField } from "components/configurationforms";
import commonStyles from "./LegacyNotificationCommonStyles.css";
const formatLegacyTypes = (legacyTypes) => Object.keys(legacyTypes).map((typeName) => ({ label: `Legacy ${legacyTypes[typeName].name}`, value: typeName }));
class LegacyNotificationForm extends React.Component {
  constructor() {
    super(...arguments);
    this.propagateMultiChange = (newValues) => {
      const { config, onChange } = this.props;
      const nextConfig = { ...config, ...newValues };
      onChange(nextConfig);
    };
    this.propagateChange = (key, value) => {
      const { config } = this.props;
      const nextConfiguration = { ...config.configuration, [key]: value };
      this.propagateMultiChange({ configuration: nextConfiguration });
    };
    this.getDefaultConfiguration = (legacyNotificationType) => {
      const { legacyTypes } = this.props;
      const { configuration } = legacyTypes[legacyNotificationType];
      const defaultConfiguration = {};
      Object.keys(configuration).forEach((configKey) => {
        defaultConfiguration[configKey] = configuration[configKey].default_value;
      });
      return defaultConfiguration;
    };
    this.handleSelectNotificationChange = (nextLegacyNotificationType) => {
      this.propagateMultiChange({
        callback_type: nextLegacyNotificationType,
        configuration: this.getDefaultConfiguration(nextLegacyNotificationType)
      });
    };
    this.handleFormFieldChange = (key, value) => {
      this.propagateChange(key, value);
    };
  }
  renderNotificationForm(config, legacyType) {
    const { configuration } = legacyType;
    const configFields = Object.keys(configuration).map((configKey) => {
      const configField = configuration[configKey];
      const configValue = config.configuration[configKey];
      return /* @__PURE__ */ React.createElement(
        ConfigurationFormField,
        {
          key: configKey,
          typeName: config.callback_type,
          configField,
          configKey,
          configValue,
          onChange: this.handleFormFieldChange
        }
      );
    });
    return /* @__PURE__ */ React.createElement("fieldset", null, configFields);
  }
  render() {
    var _a, _b, _c;
    const { config, legacyTypes, validation } = this.props;
    const callbackType = config.callback_type;
    const typeData = legacyTypes[callbackType];
    let content;
    if (typeData) {
      content = this.renderNotificationForm(config, typeData);
    } else if (callbackType) {
      content = /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: commonStyles.legacyNotificationAlert }, "Unknown legacy alarm callback type: ", /* @__PURE__ */ React.createElement("strong", null, callbackType), " Please make sure the plugin is installed.");
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      FormGroup,
      {
        controlId: "notification-legacy-select",
        validationState: validation.errors.callback_type ? "error" : null
      },
      /* @__PURE__ */ React.createElement(ControlLabel, null, "Choose Legacy Notification"),
      /* @__PURE__ */ React.createElement(
        Select,
        {
          id: "notification-legacy-select",
          placeholder: "Select Legacy Notification",
          onChange: this.handleSelectNotificationChange,
          options: formatLegacyTypes(legacyTypes),
          value: callbackType
        }
      ),
      /* @__PURE__ */ React.createElement(HelpBlock, null, (_c = (_b = (_a = validation == null ? void 0 : validation.errors) == null ? void 0 : _a.callback_type) == null ? void 0 : _b[0]) != null ? _c : "Select a Legacy Notification to use on this Event Definition.")
    )), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: commonStyles.legacyNotificationAlert }, "Legacy alarm callbacks are deprecated and will be removed with the next major release. Please switch to the new notification types as soon as possible!"), content);
  }
}
LegacyNotificationForm.defaultConfig = {
  callback_type: "",
  configuration: {}
};
export default LegacyNotificationForm;
